import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { loadMeta, openCart, loadUser, setCompany } from '../redux/actions';
import Loader from '../components/Loader';
import Navigation from './Navigation';
import Cart from '../containers/Cart';


class App extends Component {
  static propTypes = {
    loadMeta: PropTypes.func.isRequired,
    openCart: PropTypes.func.isRequired,
    loadUser: PropTypes.func.isRequired,
    setCompany: PropTypes.func.isRequired,
    user: PropTypes.object,
    company: PropTypes.object
  };

  static childContextTypes = {
    user: PropTypes.object,
    company: PropTypes.object
  };

  getChildContext() {
    return {
      user: this.props.user,
      company: this.props.company
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    }

    Promise.all([
      props.loadMeta(),
      props.loadUser()
    ]).then(_ => this.setState({loading: false}));
  }

  render() {
    return (
      <Loader loaded={!this.state.loading} className="root-loader">
        <Cart />
        <Navigation
          openCart={this.props.openCart}
          cartIsOpen={this.props.cartIsOpen}
          user={this.props.user}
          company={this.props.company}
          setCompany={this.props.setCompany}
        />
        <div id="app">
          {this.props.children}
        </div>
      </Loader>
    )
  }
}

const mapSateToProps = (state, props) => ({
  ...state.user,
  cartIsOpen: state.cart.open,
});

export default connect(
  mapSateToProps,
  {
    setCompany,
    loadUser,
    openCart,
    loadMeta
})(App);


// WEBPACK FOOTER //
// ./src/components/App.js